import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRoleConfig } from "../types/IRoleConfig";
import DefaultRoleConfig from '../data/role_config.json';
import { IScenario } from "../types/IScenario";
import { CreatorMode, EditorMode } from "../types/editorModeEnum";

export interface EditorState {
    defaultRoleConfig: IRoleConfig;
    scenarios: IScenario[];
    selectedScenario: string;
    editorMode: EditorMode;
    creatorMode: CreatorMode;
}

const initialState: EditorState = {
    defaultRoleConfig: DefaultRoleConfig as IRoleConfig,
    scenarios: [],
    selectedScenario: '',
    editorMode: EditorMode.List,
    creatorMode: CreatorMode.Main,
}

export const editorSlice = createSlice({
    name: 'editor',
    initialState,
    reducers: {
        setEditorMode: (state, action: PayloadAction<EditorMode>) => {
            if(action.payload === EditorMode.Create) {
                return {
                    ...state,
                    editorMode: action.payload,
                    creatorMode: CreatorMode.Main,
                }
            }
            return {
                ...state,
                editorMode: action.payload,
            }

        },
        setCreatorMode: (state, action: PayloadAction<CreatorMode>) => {
            return {
                ...state,
                creatorMode: action.payload,
            }
        },
        setSelectedScenario: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                selectedScenario: action.payload,
            }

        },
        setScenarios: (state, action: PayloadAction<IScenario[]>) => {
            return {
                ...state,
                scenarios: [
                    ...action.payload,
                ]
            }

        },
        appendScenario: (state, action: PayloadAction<IScenario>) => {
            return {
                ...state,
                scenarios: [
                    ...state.scenarios,
                    action.payload
                ]
            }

        }
    }
});

export const { setScenarios,
    appendScenario,
    setEditorMode,
    setCreatorMode,
    setSelectedScenario } = editorSlice.actions;
export default editorSlice.reducer;